import { api } from "./orgApi";

export async function getMaintabCatalog() {
  const { data } = await api.get("/access/maintabs/catalog");
  return data;
}

export async function getOrgMaintabDefaults({ userClass, organizationId }) {
  const { data } = await api.get("/access/maintabs/defaults", {
    params: { userClass, organizationId },
  });
  return data;
}

export async function saveOrgMaintabDefaults({ userClass, organizationId, matrix }) {
  const { data } = await api.put("/access/maintabs/defaults", {
    userClass,
    organizationId,
    matrix,
  });
  return data;
}

export async function getUserMaintabAccess(userId, { organizationId } = {}) {
  const { data } = await api.get(`/access/maintabs/users/${userId}`, {
    params: organizationId ? { organizationId } : {},
  });
  return data;
}

export async function saveUserMaintabAccess(userId, { organizationId, matrix }) {
  const { data } = await api.put(`/access/maintabs/users/${userId}`, {
    organizationId,
    matrix,
  });
  return data;
}

export async function resetUserMaintabAccess(userId, { organizationId } = {}) {
  const { data } = await api.post(
    `/access/maintabs/users/${userId}/reset`,
    {},
    { params: organizationId ? { organizationId } : {} },
  );
  return data;
}
